import { _getLogger } from '@doxyme/analytics';
import { Specs, BasicObservable } from '@doxyme/extensions-common';
import AppletCapability from '../applet';

type Constraints = Specs.PostCallApplet.Constraints;
type Applet = Specs.PostCallApplet.Applet;

const { PostCallApplet } = Specs;

/**
 * Post Call Applet stores the frames registered to any extension using this capability.
 */
export default class PostCallAppletCapability extends AppletCapability<Constraints> {
  static id = PostCallApplet.id;

  protected override readonly hasDynamicHeight = true;

  constructor() {
    super(PostCallApplet);

    this.handlers.push(
      [PostCallApplet.Actions.Attach, this.attach.bind(this)],
      [PostCallApplet.Actions.Detach, this.detach.bind(this)],
    );
  }

  /**
   * Get all frames registered to this capability
   * @description This is an observable that will update whenever frames are added or removed.
   * See {@link BasicObservable} for more information.
   * @returns All frames registered to this capability, as an observable.
   * @example
   * ```ts
   * const frames = postCallApplet.getFrames();
   * frames.onChange((frames) => {
   *  console.log('Frames changed', frames);
   * });
   * ```
   */
  getFrames(): BasicObservable<Applet[]> {
    return this._frames;
  }
}
